export default {
    'name': 'no-file',
    'width': '45',
    'height': '40',
    'viewBox': '0 0 40 45',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 12.2015V42H37.3333V0H11.8018L0 12.2015Z\' fill=\'#DBEFFF\'/><path d=\'M18 21L22.4372 35L26.0889 29.0889L31.9988 25.4384L18 21Z\' fill=\'#006CFD\'/><path d=\'M25.9748 26.1695L23.168 28.9764L28.9741 34.7825L31.781 31.9757L25.9748 26.1695Z\' fill=\'#006CFD\'/>'
}
